import { z } from 'zod';
import { Tenant } from './tenant.js';
/** The session bearer's identity as the product sees it. Service users never appear here. */
export const SessionUser = z.object({
    userId: z.string(),
    orgId: z.string(),
    email: z.string(),
    displayName: z.string().nullable(),
    isAdmin: z.boolean(),
    isSuperAdmin: z.boolean(),
    kind: z.literal('human'),
});
export const SessionResponse = z.object({
    token: z.string(),
    expiresAt: z.string().datetime(),
    user: SessionUser,
    tenant: Tenant,
});
export const MeResponse = z.object({ user: SessionUser, tenant: Tenant });
/** GET /api/auth/providers — which sign-in buttons the web shows. */
export const AuthProviders = z.object({ salesforce: z.boolean(), workos: z.boolean() });
//# sourceMappingURL=session.js.map